export class Applicationlog {
    _id: string;
    applicationId: string;
    createdDate: Date;
    userId: string;
    status: string;
    remarks: string;
}